module.exports = "/shared/img/tutorial-arrow-left.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/img/tutorial-arrow-left.png
// module id = 455
// module chunks = 13